(function () {
  'use strict';

  angular
    .module('AcaApp')
    .directive('ngToggle', directive);

  function directive() {
    var dir = {
      restrict: 'A',
      link: link
    };

    return dir;
  }

  function link($scope, element, attrs) {
    var expression = attrs.show;

    var duration = attrs.duration || 'slow';

    $scope.$watch(expression, function (newValue, oldValue) {
      if (newValue) {
        element
          .stop(true, true)
          .slideDown(duration);
      } else {
        element
          .stop(true, true)
          .slideUp(duration);
      }
    });
  }
})();